import DateTimeFilter from "../../controls/table/DateTimeFilter";
import { getCurrentLanguage } from "../../util/i18n";
import { userFriendlyTime } from "../../util/relativeTime";
import { getSafe } from "../../util/storeHelper";
import * as React from "react";
export const ENABLED_TIME = (locale) => {
    return {
        id: "enabledTime",
        name: "Enabled Time",
        description: "Time when this mod was enabled (in this profile)",
        icon: "calendar-plus-o",
        customRenderer: (mod, detail, t) => {
            const timeStamp = mod.enabledTime;
            if (detail) {
                const lang = getCurrentLanguage();
                return (React.createElement("span", null, timeStamp !== undefined
                    ? new Date(timeStamp).toLocaleString(lang)
                    : t("Never enabled")));
            }
            else {
                if (timeStamp === undefined) {
                    return React.createElement("span", null, t("Never"));
                }
                return (React.createElement("span", null, userFriendlyTime(new Date(timeStamp), t, locale())));
            }
        },
        calc: (mod) => new Date(mod.enabledTime),
        placement: "both",
        isToggleable: true,
        isDefaultVisible: false,
        edit: {},
        isSortable: true,
        sortFunc: (lhs, rhs) => (lhs.getTime() || 0) - (rhs.getTime() || 0),
        filter: new DateTimeFilter(),
    };
};
export const INSTALL_TIME = (locale) => {
    return {
        id: "installTime",
        name: "Installation Time",
        description: "Time when this mod was installed",
        icon: "calendar-plus-o",
        customRenderer: (mod, detail, t) => {
            const timeString = getSafe(mod, ["attributes", "installTime"], undefined);
            if (detail) {
                const lang = getCurrentLanguage();
                return (React.createElement("span", null, timeString !== undefined
                    ? new Date(timeString).toLocaleString(lang)
                    : t("Not installed")));
            }
            else {
                if (timeString === undefined) {
                    return React.createElement("span", null, t("Not installed"));
                }
                return (React.createElement("span", null, userFriendlyTime(new Date(timeString), t, locale())));
            }
        },
        calc: (mod) => new Date(getSafe(mod.attributes, ["installTime"], 0)),
        placement: "both",
        isToggleable: true,
        isDefaultVisible: false,
        edit: {},
        isSortable: true,
        sortFunc: (lhs, rhs) => (lhs.getTime() || 0) - (rhs.getTime() || 0),
        filter: new DateTimeFilter(),
    };
};
export const DOWNLOAD_TIME = (getApi) => {
    return {
        id: "downloadTime",
        name: "Downloaded Time",
        description: "Time when this mod's archive was downloaded",
        icon: "calendar-plus-o",
        customRenderer: (mod, detail, t) => {
            const archiveId = mod.archiveId;
            const state = getApi().getState();
            const download = state.persistent.downloads.files[archiveId];
            if (!archiveId || !download) {
                return React.createElement("span", null, t("Unknown"));
            }
            const timeString = getSafe(download, ["fileTime"], undefined);
            if (detail) {
                const lang = getCurrentLanguage();
                return (React.createElement("span", null, download.fileTime !== undefined ? (new Date(timeString).toLocaleString(lang)) : (React.createElement("span", null, t("Unknown")))));
            }
            else {
                if (timeString === undefined) {
                    return React.createElement("span", null, t("Unknown"));
                }
                return (React.createElement("span", null, userFriendlyTime(new Date(timeString), t, getApi().locale())));
            }
        },
        calc: (mod) => {
            const archiveId = mod.archiveId;
            const state = getApi().getState();
            const download = state.persistent.downloads?.files?.[archiveId];
            if (!archiveId || !download) {
                return new Date(0);
            }
            const timeString = getSafe(download, ["fileTime"], undefined);
            return timeString !== undefined ? new Date(timeString) : new Date(0);
        },
        placement: "both",
        isToggleable: true,
        isDefaultVisible: false,
        edit: {},
        isSortable: true,
        sortFunc: (lhs, rhs) => (lhs.getTime() || new Date(0).getTime()) -
            (rhs.getTime() || new Date(0).getTime()),
        filter: new DateTimeFilter(),
    };
};
